import React from 'react';

interface Props {
  label?: string;
  onChange: (e: string) => void;
  value: string;
  radioWrapperClass: string;
  options: {
    name: string;
    value: string;
    label: string;
  }[];
}

/**
 * This callback fires when a new checkbox is selected in the radio group.
 * @callback radioGroupOnChangeCallback
 * @param {value} The value of the newly selected radio checkbox.
 */

/**
 * A group of radio controls.
 *
 * @param {string} props.label The main label preceeding and labeling the entire radio group.
 * @param {radioGroupOnChangeCallback} props.onChange The callback to see changes to the radio group.
 * @param {string} props.value The checkbox to be checked by default.
 * @param {Array.{name: string, value: string, label: ReactElement}} props.options Each element is a distinct radio control.
 * @param {string} props.radioWrapperClass class inserted in the wrapping div around the radio buttons
 */
class RadioGroup extends React.Component<Props, {}> {
  static defaultProps = {
    radioWrapperClass: '',
  };

  update = (value: any) => {
    this.props.onChange(value);
  };

  render() {
    return (
      <div className="control-group">
        <label>{this.props.label}</label>
        <div className="status-radio-group">
          {this.props.options.map((option, index) => (
            <div className="radio" key={index}>
              <input
                type="radio"
                name={option.name}
                value={option.value}
                checked={option.value === this.props.value}
                onChange={this.update.bind(this, option.value)}
              />{' '}
              {option.label}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default RadioGroup;
